import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'view-design/dist/styles/iview.css';
import store from '@/store/index.js'
import websocketManager from '@/util/websocket'
import * as echarts from 'echarts'
import axios from 'axios';
import ViewUI from 'view-design';
Vue.prototype.$store = store
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(ViewUI)
Vue.use(websocketManager)
axios.defaults.timeout = 10000;
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
